// import { withStyles } from '@material-ui/core/styles'
// import Button from '@material-ui/core/Button'
// import fileMangerExplorerStyle from './components/fileManager/fileManagerExplorerStyle'

// const CmsButton = withStyles({
//   root: {
//     size: "small",
//     textTransform: 'none'
//   }
// })(Button)


const defaultFont = {
	fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
	fontWeight: "300",
	fontSize: "15px",
	// lineHeight: "1.5em",
}

const defaultButtonFont = {
	fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
	fontWeight: "600",
	fontSize: "12px",
	paddingLeft: "0px"
}

const defaultContentFont = {
	fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
	fontWeight: "300",
	fontSize: "15px",
	padding: "5px 20px"
}

const defaultContentHeaderFont = {
	fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
	fontWeight: "600",
	fontSize: "18px",
	padding: "10px 20px"
}

const defaultMainHeaderFont = {
	fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
	fontSize: "25px",
	fontWeight: "800",
	letterSpacing: "3px",
	color: "rgba(0, 102, 204, 1)",
	textShadow: '1px 2px 2px rgba(0, 0, 0, 0.3)',
	paddingLeft: "30px",
	paddingBottom: "5px"
}

const primaryColor = ['#ff0000', '#ff9900', '#ffff00', '#009933', '#00ff00', '#003399', '#b3b3b3', '#000000', '#ffffff']   // 0=red, 1=orange, 2=yellow, 3=green, 4=lime, 5=blue, 6=grey, 7=black, 8=white
const infoColor = ["#00acc1", "#26c6da", "#00acc1", "#00d3ee"]
const successColor = ["#4caf50", "#66bb6a", "#43a047", "#5cb860"]
const warningColor = ["#ff9800", "#ffa726", "#fb8c00", "#ffa21a"]
const dangerColor = ["#f44336", "#ef5350", "#e53935", "#f55a4e"]
const roseColor = ["#e91e63", "#ec407a", "#d81b60", "#eb3573"]

// 0=Very Night, 9=Normal, 14=Very Dark
const redColor = ["#ffe6e6", "#ffcccc", "#ffb3b3", "#ff9999", "#ff8080", "#ff6666", "#ff4d4d", "#ff3333", "#ff1a1a", "#ff0000", "#e60000", "#cc0000", "#b30000", "#990000", "#800000"]
const nightOrangeColor =["#fffae6", "#fff5cc", "#fff0b3", "#ffeb99", "#ffe680", "#ffe066", "#ffdb4d", "#ffd633", "#ffd11a", "#ffcc00", "#e6b800", "#cca300", "#b38f00", "#997a00", "#806600"]
const orangeColor = ["#fff5e6", "#ffebcc", "#ffe0b3", "#ffd699", "#ffcc80", "#ffc266", "#ffb84d", "#ffad33", "#ffa31a", "#ff9900", "#e68a00", "#cc7a00", "#b36b00", "#995c00", "#804d00"]
const yellowColor = ["#ffffe6", "#ffffcc", "#ffffb3", "#ffff99", "#ffff80", "#ffff66", "#ffff4d", "#ffff33", "#ffff1a", "#ffff00", "#e6e600", "#cccc00", "#b3b300", "#999900", "#808000"]
const greenColor = ["#ecf9ec", "#d9f2d9", "#c6ecc6", "#b3e6b3", "#9fdf9f", "#8cd98c", "#79d279", "#66cc66", "#53c653", "#40bf40", "#39ac39", "#339933", "#2d862d", "#267326", "#206020"]
const blueColor = ["#e6ecff", "#ccd9ff", "#b3c6ff", "#99b3ff", "#809fff", "#668cff", "#4d79ff", "#3366ff", "#1a53ff", "#0040ff", "#0039e6", "#0033cc", "#002db3", "#002699", "#002080"]
const oceanBlueColor = ["#ecf2f9", "#d9e6f2", "#c6d9ec", "#b3cce6", "#9fbfdf", "#8cb3d9", "#79a6d2", "#6699cc", "#538cc6", "#4080bf", "#3973ac", "#336699", "#2d5986", "#264d73", "#204060", ]
const DodgerBlueColor = ["#e6f5ff", "#ccebff", "#b3e0ff", "#99d6ff", "#80ccff", "#66c2ff", "#4db8ff", "#33adff", "#1aa3ff", "#0099ff", "#008ae6", "#007acc", "#006bb3", "#005c99", "#004d80"]
const purpleColor = ["#f5e6ff", "#ebccff", "#e0b3ff", "#d699ff", "#cc80ff", "#c266ff", "#b84dff", "#ad33ff", "#a31aff", "#9900ff", "#8a00e6", "#7a00cc", "#6b00b3", "#5c0099", "#4c0080"]
const brownColor = ["#f9f2ec", "#f2e6d9", "#ecd9c6", "#e6ccb3", "#dfbf9f", "#d9b38c", "#d2a679", "#cc9966", "#c68c53", "#bf8040", "#ac7339", "#996633", "#86592d", "#734d26", "#604020"]
const grayColor = ["#f2f2f2", "#e6e6e6", "#d9d9d9", "#cccccc", "#bfbfbf", "#b3b3b3", "#a6a6a6", "#999999", "#8c8c8c", "#808080", "#737373", "#666666", "#595959", "#4d4d4d", "#404040"]
const darkSlateGrey = ["#ffffff", "#eff5f5", "#e0ebeb", "#d0e1e1", "#c1d7d7", "#b1cdcd", "#a2c3c3", "#92b9b9", "#83afaf", "#73a5a5", "#639c9c", "#5a8c8c", "#507c7c", "#466d6d", "#3c5d5d"]
const goldColor = "#FFD700"
const blackColor = "#000"
const whiteColor = "#FFF"

const hexToRgb = input => {
	input = input + ""
	input = input.replace("#", "")
	let hexRegex = /[0-9A-Fa-f]/g
	if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
		throw new Error("input is not a valid hex color.")
	}
	if (input.length === 3) {
		let first = input[0]
		let second = input[1]
		let last = input[2]
		input = first + first + second + second + last + last
	}
	input = input.toUpperCase(input)
	let first = input[0] + input[1]
	let second = input[2] + input[3]
	let last = input[4] + input[5]
	return (
		parseInt(first, 16) +
		", " +
		parseInt(second, 16) +
		", " +
		parseInt(last, 16)
	)
}

const boxShadow = {
	boxShadow:
		"0 10px 30px -12px rgba(" +
		hexToRgb(blackColor) +
		", 0.42), 0 4px 25px 0px rgba(" +
		hexToRgb(blackColor) +
		", 0.12), 0 8px 10px -5px rgba(" +
		hexToRgb(blackColor) +
		", 0.2)"
}

const primaryBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(primaryColor[0]) +
		",.4)"
}

const infoBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(infoColor[0]) +
		",.4)"
}

const successBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(successColor[0]) +
		",.4)"
}

const warningBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(warningColor[0]) +
		",.4)"
}

const dangerBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(dangerColor[0]) +
		",.4)"
}

const roseBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(roseColor[0]) +
		",.4)"
}

const redBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(redColor[0]) +
		",.4)"
}

const orangeBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(orangeColor[0]) +
		",.4)"
}

const yellowBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(yellowColor[0]) +
		",.4)"
}

const greenBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(greenColor[0]) +
		",.4)"
}

const blueBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(blueColor[0]) +
		",.4)"
}

const purpleBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(purpleColor[0]) +
		",.4)"
}

const brownBoxShadow = {
	boxShadow:
		"0 4px 20px 0 rgba(" +
		hexToRgb(blackColor) +
		",.14), 0 7px 10px -5px rgba(" +
		hexToRgb(brownColor[0]) +
		",.4)"
}

const primaryCardHeader = {
	background:
		"linear-gradient(60deg, " + primaryColor[1] + ", " + primaryColor[2] + ")",
	...primaryBoxShadow
}

const infoCardHeader = {
	background:
		"linear-gradient(60deg, " + infoColor[1] + ", " + infoColor[2] + ")",
	...infoBoxShadow
}

const warningCardHeader = {
	background:
		"linear-gradient(60deg, " + warningColor[1] + ", " + warningColor[2] + ")",
	...warningBoxShadow
}

const successCardHeader = {
	background:
		"linear-gradient(60deg, " + successColor[1] + ", " + successColor[2] + ")",
	...successBoxShadow
}

const dangerCardHeader = {
	background:
		"linear-gradient(60deg, " + dangerColor[1] + ", " + dangerColor[2] + ")",
	...dangerBoxShadow
}

const roseCardHeader = {
	background:
		"linear-gradient(60deg, " + roseColor[1] + ", " + roseColor[2] + ")",
	...roseBoxShadow
}

const redCardHeader = {
	background:
		"linear-gradient(60deg, " + redColor[3] + ", " + redColor[14] + ")",
	...redBoxShadow
}

const orangeCardHeader = {
	background:
		"linear-gradient(60deg, " + orangeColor[3] + ", " + orangeColor[14] + ")",
	...redBoxShadow
}

const yellowCardHeader = {
	background:
		"linear-gradient(60deg, " + yellowColor[3] + ", " + yellowColor[14] + ")",
	...redBoxShadow
}

const greenCardHeader = {
	background:
		"linear-gradient(60deg, " + greenColor[3] + ", " + greenColor[14] + ")",
	...redBoxShadow
}

const blueCardHeader = {
	background:
		"linear-gradient(60deg, " + blueColor[3] + ", " + blueColor[14] + ")",
	...redBoxShadow
}

const purpleCardHeader = {
	background:
		"linear-gradient(60deg, " + purpleColor[3] + ", " + purpleColor[14] + ")",
	...redBoxShadow
}

const brownCardHeader = {
	background:
		"linear-gradient(60deg, " + brownColor[3] + ", " + brownColor[14] + ")",
	...redBoxShadow
}


export {
	defaultFont,
	defaultButtonFont,
	defaultContentFont,
	defaultContentHeaderFont,
	defaultMainHeaderFont,
	primaryColor,
	infoColor,
	successColor,
	warningColor,
	dangerColor,
	roseColor,
	grayColor,
	darkSlateGrey,
	blackColor,
	whiteColor,
	goldColor,
	redColor,
	nightOrangeColor,
	orangeColor,
	yellowColor,
	greenColor,
	blueColor,
	oceanBlueColor,
	DodgerBlueColor,
	purpleColor,
	brownColor,
	// systemFolderColor,
	// userFolderColor,
	primaryCardHeader,
	infoCardHeader,
	warningCardHeader,
	successCardHeader,
	dangerCardHeader,
	roseCardHeader,
	redCardHeader,
	orangeCardHeader,
	yellowCardHeader,
	greenCardHeader,
	blueCardHeader,
	purpleCardHeader,
	brownCardHeader,
	boxShadow,
	primaryBoxShadow,
	infoBoxShadow,
	successBoxShadow,
	warningBoxShadow,
	dangerBoxShadow,
	roseBoxShadow,
	redBoxShadow,
	orangeBoxShadow,
	yellowBoxShadow,
	greenBoxShadow,
	blueBoxShadow,
	purpleBoxShadow,
	brownBoxShadow,
	hexToRgb
}

